import React from 'react';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { AddressInfoDto } from '@savgroup-front-common/types';

import { $Button } from '../AvailableHandlingMethods/ChooseHandlingMethod/ChooseHandlingMethod.styles';
import messages from '../AvailableHandlingMethods/ChooseHandlingMethod/messages';

import {
  $AddressLine,
  $ChooseItemCardAddress,
} from './DisplayHomeAddress.styles';

interface ChooseItemCardAddressProps {
  address?: AddressInfoDto;
  onModifyClick?: () => void;
}

const DisplayHomeAddress: React.FC<ChooseItemCardAddressProps> = ({
  address,
  onModifyClick,
}) => {
  const personName =
    `${address?.firstname ?? ''} ${address?.lastname ?? ''}`.trim();
  const displayName = personName || address?.companyName;

  return (
    <$ChooseItemCardAddress>
      {displayName ? (
        <div>
          <b>{displayName}</b>
        </div>
      ) : undefined}
      <$AddressLine>
        {address?.address} {address?.postalCode} {address?.city}
      </$AddressLine>
      {onModifyClick ? (
        <$Button type={BUTTON_TYPES.BUTTON} naked onClick={() => onModifyClick()}>
          <SafeFormattedMessageWithoutSpread message={messages.modify} />
        </$Button>
      ) : undefined}
    </$ChooseItemCardAddress>
  );
};

export default DisplayHomeAddress;
